import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss'],
})
export class ErrorModalComponent implements OnInit {
  errorMessage = '';
  isWarningDialog = false;
  
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      fileSize?: string;
      message: string;
      isVideo?: boolean;
      format?: string;
      isDuration?: boolean;
      issue?: string;
      isWarning?: boolean;
      warningTitle?: string;
    },
    private readonly dialogRef: MatDialogRef<ErrorModalComponent>
  ) {}

  ngOnInit(): void {
    this.isWarningDialog = !!this.data.isWarning;
    
    if (!this.isWarningDialog && this.data.fileSize) {
      const format = this.data.format ? this.data.format : '.png or .jpg';
      this.errorMessage = `The file you selected is either not supported or too large, please use ${format} 
                              images smaller than ${this.data.fileSize} only.`;
    }
  }

  onProceed() {
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
